import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateConfig } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
import conn from "./components/Conn/index";
import senior from "./components/Senior/index";
import modeDialog from "./components/Mode/contDialog";
import collection from "./components/collection";
import comDialog from "./components/Com/contDialog";
import { cloneDeep } from 'lodash';
export default {
  name: "SmartLink",
  props: ["deviceDid", "deviceSn", "data", "linkOptions", "loading", 'originalServer', 'noSname', 'vendorName', 'deviceSoftwareVer'],
  data: function data() {
    return {
      // tabs标志
      activeName: "default" // 原始高级配置

    };
  },
  watch: {
    deviceSn: {
      handler: function handler(val) {}
    },
    loading: {
      handler: function handler() {
        this.$refs.collection.getData();
      }
    }
  },
  methods: {
    //串口配置-校验位
    GetCOM1Parity: function GetCOM1Parity(type) {
      switch (type) {
        case "S":
          {
            return "Space";
          }

        case "E":
          {
            return "Even";
          }

        case "M":
          {
            return "Mask";
          }

        case "O":
          {
            return "Odd";
          }

        case "N":
          {
            return "None";
          }

        default:
          return type;
      }
    },
    // 修改模式配置
    modeEdit: function modeEdit(row, index) {
      this.$refs.modeDialog.show(row, index);
    },
    // 添加模式配置
    modeAdd: function modeAdd() {
      this.$refs.modeDialog.show("", this.data.mode.length + 1);
    },
    // 删除模式配置
    modeDelete: function modeDelete(row, index) {
      var _this = this;

      this.$confirm(this.$t('lang.Button.isDelete'), this.$t('lang.Button.tips'), {
        confirmButtonText: this.$t('lang.Button.submit'),
        cancelButtonText: this.$t('lang.Button.cancel')
      }).then(function () {
        updateConfig(_this.deviceSn, _this.deviceDid, [{
          section: "mode",
          config: "smartlink",
          action: 2,
          index: [index],
          // server: "smartlink",
          options: {
            enabled: row.enabled
          },
          lists: {
            uplink: row.uplink,
            downlink: row.downlink
          }
        }]).then(function (res) {
          if (res.data.data.mess == 0) {
            _this.$message.success(_this.$t('lang.Button.successDelete'));

            _this.updateData();
          } else {
            _this.$message.error(_this.$t('lang.Button.failDelete'));
          }
        });
      });
    },
    // 修改串口配置
    comEdit: function comEdit(row, index) {
      this.$refs.comDialog.show(row, index);
    },
    // 更新数据
    updateData: function updateData() {
      this.$emit("GetConfig", {
        name: "智慧物联"
      });
    },
    saveTap: function () {
      var _saveTap = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                _context.next = 3;
                return progressControl([{
                  process: 'smartlink',
                  type: 0,
                  action: 'restart'
                }], this.deviceDid, this.deviceSn);

              case 3:
                this.loading = false;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveTap() {
        return _saveTap.apply(this, arguments);
      }

      return saveTap;
    }()
  },
  components: {
    conn: conn,
    senior: senior,
    modeDialog: modeDialog,
    comDialog: comDialog,
    collection: collection
  },
  created: function created() {}
};